export const environment = {
    production: false,
    apiUrl: 'https://apidev.connectour.com.ar/',
    publicUrl: 'https://connectour.com.ar/api_dev/images/'
};
